import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Auth from '../../Authentication/Auth';
import Api from '../../../Services/Api';

class StartOrderButton extends Component {
  constructor(props) {
    super(props);

    this.state = {
      starting: false,
    };

    this.updateSuccess = this.updateSuccess.bind(this);
    this.updateError = this.updateError.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  componentWillMount() {
    // this.fetchData(this);
    // this.postStart();
  }

  updateSuccess(order) {
    this.props.onSuccess(order);
  }

  updateError(err) {
    this.props.onError(err);
  }

  handleClick() {
    this.postStart();
  }

  // TODO: this will start order
  postStart() {
    const endPoint = `v1/fbos/${this.props.fboId}/orders/${this.props.orderId}/transition/start`;
    this.setState({ starting: true });

    this.request = Api.get(endPoint, {
      method: 'PUT',
      // body: JSON.stringify(this.buildOrder()),
      headers: {
        'Content-Type': 'application/json',
        'X-Api-Key': Auth.getBearerToken(),
      },
    }, false).then((response) => {
      if (response.order) {
        this.updateSuccess(response.order);
      }
      this.setState({ starting: false });
    }).catch((error) => {
      this.updateError(error);
      this.setState({ starting: false });
    });
  }

  render() {
    const startLabel = this.state.starting ? 'Starting ...' : 'Start';
    return (
      <div className="action left">
        <button
          className="btn btn-small btn-primary-outline"
          disabled={this.state.starting}
          onClick={this.handleClick}
        >
          {startLabel}
        </button>
      </div>
    );
  }
}


StartOrderButton.propTypes = {
  onSuccess: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
  fboId: PropTypes.number.isRequired,
  orderId: PropTypes.number.isRequired,
};
export default StartOrderButton;




// WEBPACK FOOTER //
// ./src/Containers/Orders/ActionButtons/StartOrderButton.js